const MODULE_NAME = 'SYSTEM_SURVEYS';
const SYSTEM_SURVEYS_FETCH_STARTED = MODULE_NAME + 'FETCH_STARTED';
const SYSTEM_SURVEYS_FETCH_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';

export {
  SYSTEM_SURVEYS_FETCH_STARTED,
  SYSTEM_SURVEYS_FETCH_COMPLETED
};
